import { render, staticRenderFns } from "./Takedown.vue?vue&type=template&id=35342fb0&scoped=true"
import script from "./Takedown.vue?vue&type=script&lang=js"
export * from "./Takedown.vue?vue&type=script&lang=js"
import style0 from "./Takedown.vue?vue&type=style&index=0&id=35342fb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35342fb0",
  null
  
)

export default component.exports